import { Injectable, signal } from '@angular/core';
import { Language, translations } from '../i18n/translations';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  currentLang = signal<Language>('fr');

  toggleLanguage(): void {
    this.currentLang.update(lang => (lang === 'fr' ? 'en' : 'fr'));
  }

  setLanguage(lang: Language): void {
    this.currentLang.set(lang);
  }

  translate(key: string): string {
    const parts = key.split('.');
    let value: any = translations[this.currentLang()];
    for (const part of parts) {
      value = value?.[part];
      if (value === undefined) return key;
    }
    return typeof value === 'string' ? value : key;
  }

  get<T>(key: string): T {
    const parts = key.split('.');
    let value: any = translations[this.currentLang()];
    for (const part of parts) {
      value = value?.[part];
      if (value === undefined) return undefined as T;
    }
    return value as T;
  }
}
